
/* injects from baggage-loader */

'use strict';

export default function (app) {
	app.service('ProjectUpdateSchema', function (Parse) {

		// ==================================================
		// Instantiate Objects
		// ==================================================
		let ProjectUpdate = Parse.Object.extend('Project_Updates');

		// Define 'ProjectUpdate' scheme
		let schema = [
			'title',
			'body',
			'image_src'
		];
		
		// Load schema into object prototype
		schema.forEach(function (field) {
			Object.defineProperty(ProjectUpdate.prototype, field, {
				get: function () { return this.get(field); },
				set: function (value) { return this.set(field, value); }
			});
		});

		return ProjectUpdate;

	});
}

